// "You're live" celebration shown once when all required steps are complete.
import { Button } from "../../../../../components/UI";
import { PRIMARY } from "../../../../../builders/buttonDesign.types";

import { Icon } from "./glyphs";
import { RecRow } from "./OnboardingCard";
import { CompleteStyles } from "./onboarding-complete.styles";

const OnboardingComplete = ({ status, onDismiss }) => {
  const { branchName, requiredTotal, recommended, activeBranch } = status;
  const openRecommendations = recommended.filter(step => !step.done);

  return (
    <CompleteStyles>
      <div className="ob-complete-hero">
        <div className="ob-complete-check">{Icon.check(28)}</div>
        <div className="ob-complete-main">
          <div className="ob-complete-title">
            You're live — {branchName} can now take jobs
          </div>
          <div className="ob-complete-desc">
            All {requiredTotal} required steps are done. New service requests
            will now land on your dashboard.
          </div>
        </div>
        <div className="ob-complete-actions">
          <Button
            buttonDesignType={PRIMARY}
            onClick={onDismiss}
            style={{ fontWeight: 600, whiteSpace: "nowrap" }}
          >
            Go to dashboard
          </Button>
        </div>
      </div>

      {openRecommendations.length > 0 && (
        <div className="ob-complete-rec">
          <div className="ob-complete-rec-title">
            Boost your profile{" "}
            <span className="muted">· optional, gets you more jobs</span>
          </div>
          {openRecommendations.map(step => (
            <RecRow key={step.id} step={step} activeBranch={activeBranch} />
          ))}
        </div>
      )}
    </CompleteStyles>
  );
};

export default OnboardingComplete;
